module.exports = __webpack_public_path__ + "d0d9f9ef08f109f815a4ed51a15f661e.png";